import React from "react";
import { withStyles } from "@material-ui/core";
import update from "immutability-helper";
import { I18n } from "@aws-amplify/core";
import { map, get, filter, includes, isEmpty, forEach } from "lodash";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Typography } from '@material-ui/core';

import { fetchGet } from "../../../api/fetch";
import Loader from "../../Common/Loader";
import CloseIcon from "../../Common/CloseIcon";
import AddOccurrenceForm from "./AddOccurrenceForm";
import CustomButton from "../../Common/CustomButton";
import DeleteOccurrence from "./DeleteOccurrence";
import { getLov } from "../../../utils/lov";
import { HSP } from "../../../constants/common";

const styles = {
  dialog: {
    width: "978px",
    maxWidth: "calc(100vw - 60px)",
    padding: "12px",
  },
  radio: {
    '&$checked': {
      color: '#0894a4'
    }
  },
  checked: {},
  dialog2: {
    width: "400px",
    padding: "12px",
    height: "262px"
  },
  dialog3: {
    width: "350px",
    padding: "12px",
  },
  dialogTitle: {
    textTransform: "uppercase",
    fontWeight: 500,
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    justifyContent: "flex-end",
  },
  plusIcon: {
    cursor: "pointer",
  },
  content: {
    padding: "24px 12px 12px",
  },
  actionBar: {
    marginTop: "40px",
    "& button": {
      margin: "0px 16px",
    },
  },
};

const OccurrenceForm = (props) => {
  const {
    classes,
    open,
    setOpen,
    isSaving,
    initialValues,
    submit,
    timeSlots,
    edition = false,
    deleteSchedule,
    updatedKeys,
    setUpdatedKeys,
    type,
    parentClose,
    del,
    editView = false
  } = props;
  const [hostAssociations, setHostAssociations] = React.useState();
  const [lov, setLov] = React.useState();
  const [formValues, setFormValues] = React.useState(initialValues);
  const [eView, setEView] = React.useState(false);
  const [recLine, setLine] = React.useState("");
  const [value, setValue] = React.useState('thisoccurrenceonly');

  const handleRadio = (event) => {
    setValue(event.target.value);
  };

  React.useEffect(() => {
    fetchLov();
    // eslint-disable-next-line
  }, []);

  const hostId = get(formValues, ["host", "id"]);
  React.useEffect(() => {
    if (hostId) {
      fetchHostAssociations(hostId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hostId]);

  const fetchLov = async () => {
    try {
      const scheduleTypes = await getLov("scheduleTypes");
      setLov({
        scheduleTypes: filter(
          scheduleTypes,
          (t) =>
            t.parent_schedule_type_id === (type === HSP ? 1 : 2) &&
            t.is_schedulable
        ),
      });
    } catch (e) {
      console.log(e);
    }
  };
  const handleChange = (id, index, value) => {
    // In edition mode, save the modified keys
    if (edition && !includes(updatedKeys, id)) {
      setUpdatedKeys(
        update(updatedKeys, {
          $push: [id],
        })
      );
    }

    if (id === "host" && get(value, ["id"])) {
      setFormValues(
        update(formValues, {
          host: { $set: value },
          zone: { $set: get(value, ["zone_id"]) },
        })
      );
    } else if (id === "timeType") {
      setFormValues(
        update(formValues, {
          [id]: { $set: value },
          customStart: { $set: new Date() },
          customEnd: { $set: new Date() },
        })
      );
    } else if (id === "unknownVisitors") {
      if (includes(get(formValues, ["unknownVisitors"]), value)) {
        setFormValues(
          update(formValues, {
            unknownVisitors: {
              $set: filter(
                get(formValues, ["unknownVisitors"]),
                (v) => v !== value
              ),
            },
          })
        );
      } else if (get(formValues, ["unknownVisitors"])) {
        setFormValues(
          update(formValues, {
            unknownVisitors: { $push: [value] },
          })
        );
      } else {
        setFormValues(
          update(formValues, {
            unknownVisitors: { $set: [value] },
          })
        );
      }
    } else if (id === "visitors") {
      if (includes(["selectAll", "selectNone"], index)) {
        setFormValues(
          update(formValues, {
            visitors: {
              $set: value,
            },
          })
        );
      } else if (includes(get(formValues, ["visitors"]), value)) {
        setFormValues(
          update(formValues, {
            visitors: {
              $set: filter(get(formValues, ["visitors"]), (v) => v !== value),
            },
          })
        );
      } else if (get(formValues, ["visitors"])) {
        setFormValues(
          update(formValues, {
            visitors: { $push: [value] },
          })
        );
      } else {
        setFormValues(
          update(formValues, {
            visitors: { $set: [value] },
          })
        );
      }
    } else {
      setFormValues(
        update(formValues, {
          [id]: { $set: value },
        })
      );
    }
  };

  const fetchHostAssociations = async (id) => {
    try {
      let associations = await fetchGet(`profile_associations/profiles/${id}`);
      associations = filter(
        associations,
        (ass) => get(ass, ["p1_profile", "type", "id"]) === 1
      );
      let associatedProfiles = [];
      forEach(associations, (a) => {
        if (
          includes(
            map(associatedProfiles, (p) => get(p, ["p1_profile", "id"])),
            get(a, ["p1_profile", "id"])
          )
        ) {
          get(
            filter(
              associatedProfiles,
              (p) =>
                get(p, ["p1_profile", "id"]) === get(a, ["p1_profile", "id"])
            ),
            [0, "associations"]
          ).push(get(a, ["p1_association_type"]));
        } else {
          associatedProfiles.push({
            ...a,
            associations: [get(a, ["p1_association_type"])],
          });
        }
      });
      setHostAssociations(associatedProfiles);
    } catch (e) {
      console.log(e);
    }
  };

  if (isEmpty(lov)) {
    return null;
  }

  function recurrenceLine(line) {
    if (line) {
      setLine(line)
    } else {
      setLine("")
    }
  }

  function conf(editView, formValues, initialValues) {
    if (editView) {
      setEView(true)
    } else {
      submit(formValues);
      setFormValues(initialValues);
      setHostAssociations();
    }
  }

  function handleUpdate() {
    submit(formValues, value);
    setFormValues(initialValues);
    setHostAssociations();
  }

  if (del) {
    return (
      <Dialog
        open={open}
        classes={{ paper: classes.dialog3 }}
      >
        <Grid container direction="column">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs />
              <Grid item xs={2} className={classes.closeBtn}>
                <CloseIcon closeFunction={() => { parentClose(); setOpen(false); }} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="column" className={classes.content}>
              <Grid item>{I18n.get("scheduler_deactivateConfirm")}</Grid>
              <Grid item>
                <br></br>
                <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleRadio} >
                  <FormControlLabel value="thisoccurrenceonly" control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />} label={<Typography style={{ fontFamily: 'Roboto', fontSize: "14px", letterSpacing: "0.02", color: "#1d1c1d" }} > {I18n.get("this_occurrence_only")}</Typography>} />
                  <FormControlLabel value="futureoccurrences" control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />} label={<Typography style={{ fontFamily: 'Roboto', fontSize: "14px", letterSpacing: "0.02", color: "#1d1c1d" }} > {I18n.get("future_occurrences")}</Typography>} />
                </RadioGroup>
                <Grid container justify="center" style={{ marginTop: "40px" }}>
                  <Grid item style={{ marginRight: "15px" }}>
                    <CustomButton
                      color="primary"
                      onClick={() => { parentClose(); setOpen(false); }}
                    >
                      {I18n.get("site_cancel")}
                    </CustomButton>
                  </Grid>
                  <Grid item style={{ marginLeft: "15px" }}>
                    <CustomButton
                      variant="contained"
                      color="primary"
                      onClick={() => { deleteSchedule(value) }}
                    >
                      {I18n.get("site_confirm")}
                    </CustomButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    )
  }
  else {
    return (
      <Dialog
        open={open}
        classes={{
          root: classes.dialogRoot,
          paperScrollPaper: classes.dialog,
        }}
      >
        <Grid container wrap="nowrap" direction="column" alignItems="stretch">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs className="dialogTitle">
                {edition
                  ? I18n.get("scheduler_schedulerOccurrence")
                  : I18n.get("scheduler_newSchedulerOccurrence")}
              </Grid>
              <Grid item xs={2} className={classes.closeBtn}>
                <CloseIcon
                  closeFunction={() => {
                    if (parentClose) {
                      parentClose();
                    }
                    setOpen(false);
                    setFormValues(initialValues);
                    setHostAssociations();
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            {isSaving ? (
              <Loader noDecoration height={300} />
            ) : (
              <Grid container direction="column" className={classes.content}>
                <AddOccurrenceForm
                  formValues={formValues}
                  handleChange={handleChange}
                  hostAssociations={hostAssociations}
                  timeSlots={timeSlots}
                  lov={lov}
                  edition={edition}
                  recurrenceLine={recurrenceLine}
                />
                <div style={{ paddingTop: "2px" }}>
                  {recLine}
                </div>

                <Grid
                  item
                  container
                  alignItems="center"
                  justify="center"
                  className={classes.actionBar}
                >
                  {edition && <Grid item xs />}
                  <CustomButton
                    color="primary"
                    onClick={() => {
                      if (parentClose) {
                        parentClose();
                      }
                      setOpen(false);
                      setFormValues(initialValues);
                      setHostAssociations();
                    }}
                  >
                    {I18n.get("site_cancel")}
                  </CustomButton>
                  <CustomButton
                    color="primary"
                    variant="contained"
                    onClick={() => {
                      conf(editView, formValues, initialValues);
                    }}
                    disabled={
                      isEmpty(get(formValues, ["host"])) ||
                      !get(formValues, ["zone"])
                    }
                  >
                    {I18n.get("site_confirm")}
                  </CustomButton>
                  {edition && (
                    <DeleteOccurrence deleteSchedule={deleteSchedule} openstate={del} />
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        <>
          <Dialog
            open={eView}
            classes={{ paper: classes.dialog2 }}
          >
            <Grid item xs={2} className={classes.closeBtn} style={{ position: "relative", left: "80%" }}>
              <CloseIcon
                closeFunction={() => {
                  setEView(false);
                }}
              />
            </Grid>
            <div style={{ paddingLeft: "30px", paddingTop: "15px" }}>
              <FormControl component="fieldset">
                <FormLabel component="legend" style={{ fontFamily: 'Roboto', fontSize: "14px", letterSpacing: "0.02", color: "#1d1c1d" }}>{I18n.get("apply_changes")}</FormLabel>
                <br></br>
                <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleRadio} >
                  <FormControlLabel value="thisoccurrenceonly" control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />} label={<Typography style={{ fontFamily: 'Roboto', fontSize: "14px", letterSpacing: "0.02", color: "#1d1c1d" }} > {I18n.get("this_occurrence_only")}</Typography>} />
                  <FormControlLabel value="futureoccurrences" control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />} label={<Typography style={{ fontFamily: 'Roboto', fontSize: "14px", letterSpacing: "0.02", color: "#1d1c1d" }} > {I18n.get("future_occurrences")}</Typography>} />
                </RadioGroup>
              </FormControl>
              <Grid container justify="center" style={{ marginTop: "15px" }}>
                <Grid item style={{ marginRight: "15px" }}>
                  <CustomButton
                    color="primary"
                    onClick={() => { setEView(false); }}
                  >
                    {I18n.get("site_cancel")}
                  </CustomButton>
                </Grid>
                <Grid item style={{ marginLeft: "15px" }}>
                  <CustomButton
                    variant="contained"
                    color="primary"
                    onClick={handleUpdate}
                  >
                    {I18n.get("site_confirm")}
                  </CustomButton>
                </Grid>
              </Grid>
            </div>
          </Dialog>
        </>
      </Dialog>
    );
  }
};

export default withStyles(styles)(OccurrenceForm);
